export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString('en-US', { dateStyle: 'long' });
}
